import axios from "axios";
import { getRegionFromPathname } from "./region";

const runtimeApi =
  typeof window !== "undefined" &&
  window.__APP_CONFIG__ &&
  window.__APP_CONFIG__.SERVER_ADDRESS
    ? window.__APP_CONFIG__.SERVER_ADDRESS
    : "";

const API_URL = runtimeApi || process.env.REACT_APP_SERVER_ADDRESS || "";

console.log("Using API_URL", API_URL || "<proxy>");

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const userInfoRaw = localStorage.getItem("UserInfo");
    const hospitalInfoRaw = localStorage.getItem("HospitalInfo");
    const userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : null;
    const hospitalInfo = hospitalInfoRaw ? JSON.parse(hospitalInfoRaw) : null;
    const authToken = userInfo?.authToken || hospitalInfo?.authToken;

    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }

    const region = getRegionFromPathname(window.location.pathname || "");
    if (config.headers) {
      config.headers["X-Region"] = region;
    } else {
      config.headers = { "X-Region": region };
    }

    // Let browser set multipart boundary automatically for FormData requests.
    if (config.data instanceof FormData && config.headers) {
      delete config.headers["Content-Type"];
    }

    console.log("API Request:", config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log("API Response:", response.status, response.statusText);
    return response;
  },
  (error) => {
    if (error.response) {
      console.error("Response Error:", error.response.status, error.response.data);
    } else if (error.request) {
      console.error("Network Error: No response from server", error.request);
      console.error(`Make sure backend server is running on ${API_URL || "<proxy>"}`);
    } else {
      console.error("Request Setup Error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
